export const formTitleClassName =
  "text-base_x tablet:text-base_l font-normal mb-[5px] leading-5";
export const labelClassName = "text-base font-normal text-center w-full";
export const inputBlockClassName = "my-[8px] w-[225px]";
export const inputClassName =
  "rounded-middle bg-white h-[30px] border-[1px] border-gray_selected text-center px-[5px]";
